export default __webpack_public_path__ + "static/media/store.0e25b18e.png";